export { default } from './NavbarAiOptIn';
